<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import AppShell from '@/components/AppShell.vue';

const route = useRoute();
const bare = computed(() => route.meta.bare === true);
</script>

<template>
  <RouterView v-if="bare" />
  <AppShell v-else>
    <!-- Переход между экранами: короткий fade+подъём, `out-in` чтобы страницы
         не накладывались. Отключается при prefers-reduced-motion (global.css). -->
    <RouterView v-slot="{ Component, route: current }">
      <Transition name="page" mode="out-in">
        <component :is="Component" :key="current.path" />
      </Transition>
    </RouterView>
  </AppShell>
</template>
